import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/timon-studler-ABGaVhJxwDQ-unsplash.jpeg";

function OffentligSektor() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.offentligSektor.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.offentligSektor.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/offentlig-sektor-tilgjengelige-dokumenter"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.offentligSektor.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.offentligSektor.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.offentligSektor.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.offentligSektor.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.offentligSektor.sections.pdfService.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.offentligSektor.sections.pdfService.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.offentligSektor.sections.pdfChallenge.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.offentligSektor.sections.pdfChallenge.content")}

              <a href="/artikler/tilgjengelighetsdirektivet" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.offentligSektor.sections.pdfChallenge.link")}
              </a>
              {i18next.t("pages.articles.list.offentligSektor.sections.pdfChallenge.content2")}
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.offentligSektor.sections.solution.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.offentligSektor.sections.solution.content")}</p>
            <p className="mt-4 mb-2">{i18next.t("pages.articles.list.offentligSektor.sections.solution.subtitle")}</p>
            <ul className="list-disc list-outside ml-6 mt-2 mb-4">
              <li>{i18next.t("pages.articles.list.offentligSektor.sections.solution.features.1")}</li>
              <li>{i18next.t("pages.articles.list.offentligSektor.sections.solution.features.2")}</li>
              <li>{i18next.t("pages.articles.list.offentligSektor.sections.solution.features.3")}</li>
            </ul>
            <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className=" underline hover:text-contrast-ink">
              {i18next.t("pages.articles.list.offentligSektor.sections.solution.readMore")}
            </a>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.offentligSektor.sections.quality.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.offentligSektor.sections.quality.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.offentligSektor.sections.advice.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.offentligSektor.sections.advice.content")}
              <a href="/docengine" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.offentligSektor.sections.advice.link")}
              </a>
              {i18next.t("pages.articles.list.offentligSektor.sections.advice.content2")}
            </p>
            <p className="mt-6">
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.offentligSektor.sections.advice.cta")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OffentligSektor;
